import styled from 'styled-components';

export const MapBox = styled.div`
  width: 100%;
  height: auto;
`;

export const FallbackMessage = styled.div`
  font-size: ${({ theme }) => theme.fontSize.medium};
  padding-bottom: ${({ theme }) => theme.spacing.s2};
  color: #666;
  font-style: italic;
`;

export const ErrorMessage = styled.div`
  padding: ${({ theme }) => theme.spacing.s4};
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: ${({ theme }) => theme.spacing.s1};
  color: #856404;
  margin-bottom: ${({ theme }) => theme.spacing.s4};
`;

export const RouteContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.s4};
  text-align: center;
  color: #666;
`;
